import dynamic from "next/dynamic";
import {useEffect} from "react";

const Picturefill = dynamic(() => import("picturefill"), {
  loading: () => <p>Loading...</p>,
  ssr: false,
});

const Home = () => {
  useEffect(() => {
    <Picturefill />;
  }, []);

  return (
    <>
      <div className="flex justify-between px-4 lg:px-20 lg:gap-x-10">
        <div className="lg:w-4/12 py-5 lg:py-10 flex flex-col items-center">
          <img src="/logos.svg" alt="Raha" className="px-10 h-44" />
          <div className=" py-6 space-y-6 text-center">
            <h2
              className="text-xl lg:text-2xl font-Medium text-darkish-purple"
              dir="rtl"
            >
              نشكركم على دعمكم وثقتكم!
              <br />
              حاليًا قاعدين نطور ونبني تجربة جديدة لكم،
              <br />
              وقريبًا بنرجع لكم بشكل أفضل!
            </h2>
            <h2 className="text-xl lg:text-2xl font-Medium text-darkish-purple">
              Thank you for your continuous support.
              <br />
              We are currently working on an upgraded experience for you.
              <br />
              We’ll be back soon, stronger and better!
            </h2>
          </div>

          <img
            src="/logo.svg"
            alt="Raha"
            className="w-48 pt-24 pb-4 m-auto lg:pt-5"
          />
        </div>
        <div className="lg:w-8/12 hidden lg:block">
          <img src="/ribbons.svg" alt="Raha" className="py-16" />
        </div>
      </div>
      <div className="px-4 lg:px-20">
        <p className="py-4 text-sm border-t text-darkish-purple border-darkish-purple opacity-70">
          Baqal For Refrigeration, Warehousing and Food Markets Co SPC |
          WadiyanReal Estate Company Storage House <br /> Ardiya 6, Block 002,
          Plot 000250, Farwaniya, Kuwait 92400
        </p>
      </div>
    </>
  );
};

export default Home;
